import { trackEvent } from '@pb/utils'

const trackAddVoucher = (voucherCode: string): void => {
  trackEvent({
    event_type: 'trackAddVoucher',
    event_category: 'trackAddVoucher',
    event_id: 'trackAddVoucher',
    event_label: voucherCode,
  })
}

const trackVoucherPopup = (): void => {
  trackEvent({
    event_type: 'trackVoucherPopup',
    event_category: 'trackVoucherPopup',
    event_id: 'trackVoucherPopup',
  })
}

const redeemVoucher = (offerToSend: string[]): void => {
  trackEvent({
    event_type: 'redeemVoucher',
    event_category: 'redeemVoucher',
    event_id: 'redeemVoucher',
    event_label: offerToSend,
  })
}

const viewReminderBanner = (): void => {
  trackEvent({
    event_type: 'viewReminderBanner',
    event_category: 'viewReminderBanner',
    event_id: 'viewReminderBanner',
  })
}

const closeVoucherBanner = (): void => {
  trackEvent({
    event_type: 'closeVoucherBanner',
    event_category: 'closeVoucherBanner',
    event_id: 'closeVoucherBanner',
  })
}

export { trackAddVoucher, trackVoucherPopup, redeemVoucher, viewReminderBanner, closeVoucherBanner }
